import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtApi } from '../services/apis';

const PrivateRoute = ({ children, loading }) => {
  const [isLogin, setIsLogin] = useState('pending');
  const navigate = useNavigate();

  const fetchData = async () => {
    await jwtApi
      .verify()
      .then(() => {
        setIsLogin('auth');
      })
      .catch(() => {
        setIsLogin('notAuth');
      });
  };

  useEffect(() => {
    fetchData();
  }, [children, isLogin]);

  switch (isLogin) {
    case 'auth':
      return children;
    case 'notAuth':
      navigate('/login');
      break;
    case 'pending':
      return loading;
    default:
      return loading;
  }
};
export default PrivateRoute;
